import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/lib/auth";
import { AuthLayout } from "@/components/auth-layout";
import { Brand } from "@/components/brand";
import { Button, Field } from "@/components/kit";
import { useToast } from "@/components/toast";

export function LoginForm({ role }) {
  const navigate = useNavigate();
  const { login } = useAuth();
  const toast = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const isAdmin = role === "admin";

  const submit = async (e) => {
    e?.preventDefault();
    setError("");
    if (!email.trim() || !password) return setError("Renseignez votre e-mail et votre mot de passe.");
    setLoading(true);
    try {
      const u = await login(email.trim(), password, role);
      toast(`Bienvenue ${u.first_name || u.name}`);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={isAdmin ? "Espace gérant" : "Connexion agent"} testID={isAdmin ? "admin-login-screen" : "login-screen"}>
      <div className="lg:hidden"><Brand compact /></div>
      <h2 className="t-h1 mt-3">{isAdmin ? "Accès administrateur sécurisé" : "Heureux de vous revoir"}</h2>
      <p className="t-body">
        {isAdmin
          ? "Cet espace est strictement réservé au gérant et à ses collaborateurs autorisés."
          : "Connectez-vous pour suivre vos recommandations et vos commissions."}
      </p>
      <form onSubmit={submit} className="flex flex-col gap-4" noValidate>
        <Field testID="login-email-input" label={isAdmin ? "Identifiant (e-mail)" : "E-mail"} value={email} onChangeText={setEmail} type="email" autoComplete="email" placeholder="vous@exemple.fr" />
        <Field testID="login-password-input" label="Mot de passe" value={password} onChangeText={setPassword} type="password" autoComplete="current-password" placeholder="••••••••" />
        {error ? <p data-testid="login-error" role="alert" className="text-sm text-[#EB5757]">{error}</p> : null}
        <Button testID="login-submit-button" type="submit" title="Se connecter" size="lg" loading={loading} />
      </form>
      <Button testID="login-forgot-button" title="Mot de passe oublié ?" variant="ghost" onClick={() => navigate("/forgot-password")} />
      {!isAdmin && (
        <Button testID="login-register-link" title="Pas encore de compte ? S'inscrire" variant="secondary" onClick={() => navigate("/register", { replace: true })} />
      )}
    </AuthLayout>
  );
}

export function Login() {
  return <LoginForm role="agent" />;
}

export function AdminLogin() {
  return <LoginForm role="admin" />;
}
